import { render, staticRenderFns } from "./FrequencyMode.vue?vue&type=template&id=1e7b70f8&scoped=true&"
import script from "./FrequencyMode.vue?vue&type=script&lang=js&"
export * from "./FrequencyMode.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyMode.vue?vue&type=style&index=0&id=1e7b70f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b70f8",
  null
  
)

/* custom blocks */
import block0 from "./FrequencyMode.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports